import { Ref, ref } from 'vue';
import { asStore } from '@src/application/store/as-store.js';

export function usePageTitleComposable() {
    const pageTitle = asStore<Ref<string|null>>('pageTitle', () => ref(null));

    return {
        pageTitle,
    };
}
